import { render, staticRenderFns } from "./BaseImageCard.vue?vue&type=template&id=4d7372eb&scoped=true"
import script from "./BaseImageCard.vue?vue&type=script&lang=js"
export * from "./BaseImageCard.vue?vue&type=script&lang=js"
import style0 from "./BaseImageCard.vue?vue&type=style&index=0&id=4d7372eb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7372eb",
  null
  
)

export default component.exports